import "./Backdrop.css";
export default function Backdrop(){
    return (
        <div className="backdrop"></div>
    )
}